import { combineReducers } from "@reduxjs/toolkit";
import { AuthApis } from "./Api/auth";
import userRRBReducer from "./slice"
import { CommonApis } from "./Api/common";
import { AuditsApis } from "./Api/audits";
import { CenApis } from "./Api/cen";
import { AdminsApis } from "./Api/admins";
import { UsersApis } from "./Api/users";
import { DashboardApis } from "./Api/dashboard";
import { CentreApis } from "./Api/masterDataApi/centre";
import { RrbApis } from "./Api/masterDataApi/rrb";
import { StateApis } from "./Api/masterDataApi/state";
import { CityApis } from "./Api/masterDataApi/city";
import {  SupportTicketApis } from "./Api/supportTicket";
import { AuditsQuestionsApis } from "./Api/auditsQuestions";
import { AuditsImagesApis } from "./Api/auditsImages";
import { AuditsFormExtrasApis } from "./Api/auditsFormExtras";
import toastSlice from "./toastSlice"
import cenReducer from "./cenSlice"
import { EcaApis } from "./Api/ecaAudit";
import { ReAuditsApis } from "./Api/reAudits";
import { DuplicateAuditsApis } from "./Api/duplicateAudits";
import { HistoryApis } from "./Api/history";
import { AnnouncementApis } from "./Api/announcement";
/******************* 
@purpose : root reducer
@return : combine reducers
******************/
export default () =>
    combineReducers({
        usertoken: userRRBReducer,
        toast:toastSlice,
        cen: cenReducer,
        [AuthApis.reducerPath]: AuthApis.reducer,
        [CommonApis.reducerPath]: CommonApis.reducer,
        [AuditsApis.reducerPath]: AuditsApis.reducer,
        [CenApis.reducerPath]: CenApis.reducer,
        [AdminsApis.reducerPath]: AdminsApis.reducer,
        [UsersApis.reducerPath]: UsersApis.reducer,
        [DashboardApis.reducerPath]: DashboardApis.reducer,
        [RrbApis.reducerPath]:RrbApis.reducer,
        [StateApis.reducerPath]:StateApis.reducer,
        [CityApis.reducerPath]:CityApis.reducer,
        [CentreApis.reducerPath]:CentreApis.reducer,
        [SupportTicketApis.reducerPath]:SupportTicketApis.reducer,
        [AuditsQuestionsApis.reducerPath]:AuditsQuestionsApis.reducer,
        [AuditsImagesApis.reducerPath]:AuditsImagesApis.reducer,
        [AuditsFormExtrasApis.reducerPath]:AuditsFormExtrasApis.reducer,
        [EcaApis.reducerPath]:AuditsFormExtrasApis.reducer,
        [ReAuditsApis.reducerPath]:ReAuditsApis.reducer,
        [DuplicateAuditsApis.reducerPath]:DuplicateAuditsApis.reducer,
        [HistoryApis.reducerPath]: HistoryApis.reducer,
        [AnnouncementApis.reducerPath]: AnnouncementApis.reducer
        // fuelsData: fuelSlice,
        // [fuelApi.reducerPath]: fuelApi.reducer,
     
    });

/******************* 
@purpose : RTK Query middlwares
@return : array of middlewares
******************/
export const getReducerMiddlewares = () => [
    // fuelApi.middleware,
    AuthApis.middleware,
    CommonApis.middleware,
    AuditsApis.middleware,
    CenApis.middleware,
    AdminsApis.middleware,
    UsersApis.middleware,
    DashboardApis.middleware,
    RrbApis.middleware,
    StateApis.middleware,
    CityApis.middleware,
    CentreApis.middleware,
    SupportTicketApis.middleware,
    AuditsQuestionsApis.middleware,
    AuditsImagesApis.middleware,
    AuditsFormExtrasApis.middleware,
    EcaApis.middleware,
    ReAuditsApis.middleware,
    DuplicateAuditsApis.middleware,
    HistoryApis.middleware,
    AnnouncementApis.middleware
];